import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../contexts/AuthContext'
import CustomerProfile from '../components/CustomerProfile'
import LanguageToggle from '../components/LanguageToggle'
import UserEmailBadge from '../components/UserEmailBadge'

const CustomerProfilePage = () => {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()
  const { t } = useTranslation('common')

  const handleLogout = async () => {
    const { error } = await signOut()
    if (error) console.error('Error signing out:', error)
    navigate('/login')
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-6">
            <h1 className="text-3xl font-bold text-gray-900">
              <span className="text-[#FF1B54]">Interactive </span>
              <span>Business</span>
            </h1>
            <div className="flex items-center space-x-4">
              <LanguageToggle />
              <UserEmailBadge email={user?.email} showProfileMenu />
              <button
                onClick={handleLogout}
                className="rounded-md bg-[#FF1B54] px-4 py-2 text-sm font-medium text-white hover:bg-[#E1174C]"
              >
                {t('navigation.logout')}
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <CustomerProfile onNavigateToDashboard={() => navigate('/dashboard')} />
      </main>
    </div>
  )
}

export default CustomerProfilePage
